
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apipages/libraries/examples",
      function () {
        return require("private-next-pages/apipages/libraries/examples/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apipages/libraries/examples"])
      });
    }
  